// Full-document render of the Oscar account order-detail view: PageSkeleton
// wrapping the legacy stearns orders page -- the "Your Account / Your Orders /
// {number}" breadcrumbs, the "Order: {number}" heading, the AccountRichOrder
// block (from the account_rich_order_json seam), and the customer-service
// info block. The order-details accordion is owned by AccountRichOrder's own
// disclosure state.
import React from "react";

import { templates } from "@reactivated";

import { AccountRichOrder } from "../components/AccountRichOrder";
import { CustomerServiceInfoBlock } from "../components/CustomerServiceInfoBlock";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.OrderDetailDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <div className="l-capped-width u-margin-bottom--xl u-full-width-title order-list">
            <section className="breadcrumbs-block">
                <a href={props.profile_url}>Your Account</a> /{" "}
                <a href={props.order_list_url}>Your Orders</a> /{" "}
                {props.order_number}
            </section>

            <h2>Order: {props.order_number}</h2>

            <div className="content__copy--full-width content__orders-page">
                <div className="orders">
                    <ul className="orders__list">
                        <li className="orders__list-item">
                            <div className="content__copy--full-width order-summary-wrapper">
                                <AccountRichOrder
                                    payload={props.account_rich_order_json}
                                />
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        {props.cs_info && <CustomerServiceInfoBlock info={props.cs_info} />}
    </PageSkeleton>
);
